import style from '@/fsd/shared/ui/static/css/commonStyle.module.scss';
import cx from 'classnames';
import { ListFilter } from 'lucide-react';
import React, { ReactNode } from 'react';
import { ISortStatuses } from '../model/types/ISortStatuses';

interface IProps {
  name?: ReactNode;
  event?: React.MouseEventHandler<HTMLDivElement>;
  additionalClass?: string;
  sortable?: boolean;
  onSortClick?: () => void;
  sortStatus?: ISortStatuses;
  filterValue?: string;
  style?: React.CSSProperties;
  className?: string;
}

export const HeaderTableItem = ({
  name,
  event,
  additionalClass,
  sortable,
  onSortClick,
  sortStatus,
  filterValue,
  style: customStyle,
  className,
}: IProps) => {
  const addedClass = () => {
    let preparedClass = '';
    if (additionalClass) {
      preparedClass = additionalClass;
    }
    return preparedClass;
  };

  return (
    <>
      <div
        className={cx(style.headerTableItem, style[addedClass()], className)}
        onClick={event}
        style={customStyle}
      >
        {name}
        {sortable && (
          <div onClick={onSortClick} className={cx(style.headerTableItemIco)}>
            <ListFilter
              className={style[sortStatus || '']}
              width={16}
              height={16}
            />
          </div>
        )}
        {filterValue}
      </div>
    </>
  );
};

export default HeaderTableItem;
